import React from 'react';
import { usePermissions } from '../hooks/usePermissions';
import { Navigate } from 'react-router-dom';

const PermissionGuard = ({ 
    children, 
    requiredArea, 
    requiredPermission = 'read',
    fallbackPath = '/home/dashboard',
    showLoading = true 
}) => {
    const { permissions, loading, hasPermission } = usePermissions();

    if (loading && showLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="mt-2 text-gray-600">Loading permissions...</p>
                </div>
            </div>
        );
    }

    if (!requiredArea) {
        return children;
    }

    if (!hasPermission(requiredArea, requiredPermission)) {
        return <Navigate to={fallbackPath} replace />;
    }

    return children;
};

export default PermissionGuard; 